//dependencias
import React, { Component } from 'react';

//componentes
import DosificacionDE from './dosificacionDE'

class Index extends Component {

    render(){
        return(
            <div>
                <DosificacionDE />
            </div>
        );
    }

}
export default Index;